import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { ThankYouComponent } from './components/thank-you/thank-you.component';


const routes: Routes = [
  // {
  //   path: '',
  //   component: WelcomeComponent,
  // },
  {
    path: 'announcement',
    loadChildren:  () => import('./features/announcement/announcement.module').then(m => m.AnnouncementModule)
  },
  {
    path: 'captcha',
    loadChildren:  () => import('./features/captcha/captcha.module').then(m => m.CaptchaModule)
  },
  {
    path: 'menu',
    loadChildren:  () => import('./features/menu/menu.module').then(m => m.MenuModule)
  },
  {
    path: 'forms',
    loadChildren:  () => import('./features/form-nodes/form-nodes.module').then(m => m.FormNodesModule)
  },
  {
    path: 'chatqueue', 
    loadChildren:  () => import('./features/chatqueue/chatqueue.module').then(m => m.ChatqueueModule)
  },
  {
    path: 'chat',
    loadChildren:  () => import('./features/livechat/livechat.module').then(m => m.LivechatModule)
  },
  {
    path: 'thank-you',
    component: ThankYouComponent,
  },
  {
    path: '**',
    component: WelcomeComponent,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
